import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Button } from '@mui/material';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import { useTranslation } from 'react-i18next';

interface DDTLineProps {
  handleSetTransportDocuments: (ref) => void; // questo ANY è da cambiare con
}
function TransportDocumentRefLineForm(params: DDTLineProps) {
  const { t } = useTranslation();
  const { handleSetTransportDocuments } = params;

  return (
    <EnhancedForm
      hideControls
      onSubmit={handleSetTransportDocuments}
      formId="refLineUpdate"
      autoStyleLayout={true}
      columns={2}>
      <IdentityField
        name="ref"
        component={TextFieldAdapter}
        label={t('global.transfer_document_ref')}
        type="text"
        required
      />
      <Button variant="contained" form="refLineUpdate" type="submit">
        <ArrowForwardIcon />
      </Button>
    </EnhancedForm>
  );
}

export default TransportDocumentRefLineForm;
